const breadCrumb = "Diário Digital - Ausência do Servidor";

const routes = [
  {
    path: "/ausencia-do-servidor",
    name: "ausencia-do-servidor",
    meta: {
      allowedPermissions: ["ausencia_docente_list", "ausencia_docente_delete"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/AusenciaDoServidor/AusenciaDoServidorHome.vue"
      ),
  },
  {
    path: "/ausencia-do-servidor/novo",
    name: "ausencia-do-servidor-novo",
    meta: {
      allowedPermissions: ["ausencia_docente_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/AusenciaDoServidor/AusenciaDoServidorCad.vue"
      ),
  },
  {
    path: "/ausencia-do-servidor/:id/editar",
    name: "ausencia-do-servidor-editar",
    meta: {
      allowedPermissions: ["ausencia_docente_update", "ausencia_docente_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/AusenciaDoServidor/AusenciaDoServidorEdit.vue"
      ),
  },
];

export default routes;
